import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { BASE_URL, OG_IMAGE } from '../utils/seo';
import { enterUp } from '../utils/animations';
import { CostTable } from '../components/program/CostTable';
import { PricingClarity } from '../components/program/PricingClarity';
import { SavingsCalculator } from '../components/program/SavingsCalculator';
import { WhatsIncluded } from '../components/program/WhatsIncluded';
import { TermsSection } from '../components/program/TermsSection';
import { GuaranteeSection } from '../components/program/GuaranteeSection';
import { PageCTA } from '../components/PageCTA';

export default function Program() {
    return (
        <div data-testid="program-page">
            <Helmet>
                <title>The Program & Pricing - White Glove Hiring</title>
                <meta name="description" content="One program that grows with you. Our fee decreases as the relationship matures. Precision hiring, structured onboarding, monthly oversight, and a free replacement guarantee." />
                <meta property="og:title" content="The Program & Pricing - White Glove Hiring" />
                <meta property="og:description" content="One program that grows with you. Our fee decreases as the relationship matures. A real partner, not a placement service." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`${BASE_URL}/program`} />
                <meta property="og:image" content={OG_IMAGE} />
                <link rel="canonical" href={`${BASE_URL}/program`} />
            </Helmet>

            <section className="bg-navy-900 hero-pattern pt-36 pb-20">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <motion.div {...enterUp}>
                        <p className="text-gold-400 text-xs font-bold tracking-[0.3em] uppercase font-inter mb-4">The Program</p>
                        <h1 className="font-montserrat font-black text-4xl md:text-5xl lg:text-6xl text-white tracking-tight leading-tight">
                            One Program. No Tiers. No Guesswork.
                        </h1>
                        <p className="text-gray-300 text-lg mt-5 max-w-xl leading-relaxed">
                            One program that grows with you. Our fee decreases as the relationship matures. A real partner, not a placement service.
                        </p>
                    </motion.div>
                </div>
            </section>

            {/* Pricing Clarity + Cost Transparency */}
            <PricingClarity />
            <CostTable />
            <SavingsCalculator />
            <WhatsIncluded />
            <TermsSection />
            <GuaranteeSection />

            <PageCTA
                headline="Ready to Build Something That Lasts?"
                sub="One conversation. No pressure. We'll tell you exactly what we'd recommend and why."
                testId="program-cta"
            />
        </div>
    );
}
